import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailHistoryComponent } from './email-history.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { PaginatorModule } from 'primeng/paginator';
import { NgxPaginationModule } from 'ngx-pagination';



@NgModule({
  declarations: [
    EmailHistoryComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: EmailHistoryComponent
      }
    ]),
    SharedModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    PaginatorModule,
    NgxPaginationModule
  ]
})
export class EmailHistoryModule { }
